import type { PropsWithChildren } from 'react';

import { FormField, Label, Paragraph } from '@zillow/constellation';

import YesAndNoExpansion from '../../../Widgets/YesAndNoExpansion';

type Props = {
  yesHandler: () => void;
  noHandler: () => void;
  yesActive: boolean;
  dataTest?: string;
  className?: string;
  subTitle?: string;
  disabled?: boolean;
};

export default function SecurityDepositYesAndNoExpansion({
  children,
  subTitle,
  dataTest,
  disabled,
  ...rest
}: PropsWithChildren<Props>) {
  return (
    <FormField
      disabled={disabled}
      label={
        <>
          <Label size="lg">Will you collect a security deposit?</Label>
          {subTitle && <Paragraph>{subTitle}</Paragraph>}
        </>
      }
      control={
        <YesAndNoExpansion data-test={dataTest} disabled={disabled} {...rest}>
          {children}
        </YesAndNoExpansion>
      }
    />
  );
}
